module.exports = __webpack_public_path__ + "img/step-4.2f331836.png";